import {loadingDialog_show, messageBox_Show} from "../../actions";
import {getApiConfig} from "../../utilities";

export const ActionTypes = {
  SELECT_SUBSCRIPTION_GROUP: 'SELECT_SUBSCRIPTION_GROUP',
  NEXT_STEP: 'NEXT_STEP',
  GOTO_STEP: 'GOTO_STEP',
  LOAD_SUBSCRIPTIONS_REQUEST: 'LOAD_SUBSCRIPTIONS_REQUEST',
  LOAD_SUBSCRIPTIONS_RESPONSE: 'LOAD_SUBSCRIPTIONS_RESPONSE',
  UPDATE_PAYMENT_INFO: 'UPDATE_PAYMENT_INFO',
  SUBMIT_PAYMENT_REQUEST: 'SUBMIT_PAYMENT_REQUEST',
  SUBMIT_PAYMENT_RESPONSE: 'SUBMIT_PAYMENT_RESPONSE',
  SELECT_SUBSCRIPTION: 'SELECT_SUBSCRIPTION'
}

export const selectSubscriptionGroup = subscriptionGroup => ({
  type: ActionTypes.SELECT_SUBSCRIPTION_GROUP,
  payload: {subscriptionGroup}
})

export const selectSubscription = (groupName, subscription) => ({
  type: ActionTypes.SELECT_SUBSCRIPTION,
  payload: {groupName, subscription}
})

export const goToNextStep = () => {
  return (dispatch, getState) => {
    const {purchase} = getState();
    const {step} = purchase;
    // add here some logic when needed
    switch (step) {
      case 1: // going away from buying program type
        dispatch({type: ActionTypes.NEXT_STEP, payload: {step: step + 1}});
        break;
      case 2: // going away from program confirmation
        dispatch({type: ActionTypes.NEXT_STEP, payload: {step: step + 1}});
        break;
      default:
        messageBox_Show(true, 'error', 'Error', 'Invalid step identifier. Contact administrator.')(dispatch);
    }
  }
}

export const goToStep = step => ({type: ActionTypes.GOTO_STEP, payload: {step}});

export const loadSubscriptions = fabricatorId => {
  return (dispatch) => {
    dispatch(loadingDialog_show(true, "Loading...", "Loading available subscriptions, please wait..."));
    dispatch({type: ActionTypes.LOAD_SUBSCRIPTIONS_REQUEST});
    const {get} = getApiConfig('Public');
    return get(`/subscriptions/${fabricatorId}`)
      .then(subs => {
        dispatch({type: ActionTypes.LOAD_SUBSCRIPTIONS_RESPONSE, payload: {subs}});

        dispatch(loadingDialog_show(false));
      })
  }
}


export const updatePaymentInfo = paymentInfo => ({
  type: ActionTypes.UPDATE_PAYMENT_INFO,
  payload: {paymentInfo}
})


export const performPayment = paymentInfo => {
  return (dispatch) => {
    dispatch(loadingDialog_show(true, "Loading...", "Performing payment, please wait..."));
    dispatch({type: ActionTypes.SUBMIT_PAYMENT_REQUEST});

    const {post} = getApiConfig('Public');
    return post(paymentInfo, 'PaySubscription')
      .then(res => {
        dispatch({type: ActionTypes.SUBMIT_PAYMENT_RESPONSE, payload: {res}});

        dispatch(loadingDialog_show(false));

        dispatch(goToStep(4)); // thank you
      });
  }
}
